import { createRef } from 'react'

require('jquery-ui/ui/widgets/slider')

export default class SliderInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      disatance: null
    }

    this.sliderRef = createRef(null)
  }

  UNSAFE_componentWillMount () {
    if (this.props.value) this.setState({ distance: this.props.value })
  }

  componentDidMount () {
    const { value, onChange, step } = this.props
    const slider = $(this.sliderRef.current)
    slider.slider({
      min: 0,
      step: step || 1,
      max: 300,
      animate: 'fast',
      range: 'min',
      value: parseFloat(value || 0),
      slide: (e, ui) => {
        this.setState({ distance: ui.value ? ui.value : null })
      },
      change: (e, ui) => _.isFunction(onChange) && onChange(ui.value)
    })
  }

  render () {
    const { name, field, customClass, placeholder } = this.props
    const { distance } = this.state
    return (
      <div className={`${customClass} form-control fake-input fake-slider labelholder show-labelholder`} data-label={placeholder || ''}>
        <input
          type='hidden'
          name={name}
          defaultValue={distance}
          id={field}
          readOnly
        />
        <div className='ui-slider' ref={this.sliderRef}>
          <div className='ui-slider-range ui-widget-header ui-corner-all ui-slider-range-min' />
          <div className='ui-slider-handle'>{distance ? `${distance} km` : <span className='fa fa-ellipsis-h' />}</div>
        </div>
        <div className='remover' onClick={this._clear.bind(this)} />
      </div>
    )
  }

  _clear () {
    $(this.sliderRef.current).slider('value', 0)
    this.setState({ distance: null }, () => {
      _.isFunction(this.props.onChange) && this.props.onChange(null)
    })
  }
}

SliderInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  field: PropTypes.string.isRequired,
  value: PropTypes.string,
  customClass: PropTypes.string,
  onChange: PropTypes.func,
  step: PropTypes.number
}
